import React from 'react'
import styled, { useTheme } from '~/ui/styled'
import { BetweenFlex, Text, IconFont, CenterFlex } from '~components/El'

type TabOption = string | { label: string; value: string, icon?: string, iconColor?: string, iconSize?: number }

interface TabsProps {
  tabs: TabOption[]
  active: string
  onChange: (value: string | { label: string; value: string, icon?: string, iconColor?: string, iconSize?: number }) => void
  height?: number
}

const TabsContainer = styled(BetweenFlex)`
  flex-direction: row;
  width: 100%;
  padding: 3px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.background};
`

const TabItem = styled(CenterFlex)<{ active: boolean; $height: number }>`
  flex: 1;
  flex-direction: row;
  height: ${({ $height }) => $height}px;
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  background-color: ${({ active, theme }) => (active ? theme.colors.primary : 'transparent')};
  cursor: pointer;
`

const TabText = styled(Text)<{ active: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ active, theme }) => (active ? theme.colors.textLight : theme.colors.text)};
  font-weight: ${({ active }) => (active ? 600 : 400)};
`

export const Tabs: React.FC<TabsProps> = ({ tabs, active, onChange, height = 40 }) => {
  const theme = useTheme()
  return (
    <TabsContainer>
      {tabs.map((item, index) => {
        const label = typeof item === 'string' ? item : item.label
        const value = typeof item === 'string' ? item : item.value
        const isActive = active === value
        const icon = typeof item === 'string' ? "" : item.icon
        const iconSize = typeof item === 'string' ? 0 : (item.iconSize || 16)
        return (
          <TabItem
            key={index}
            active={isActive}
            $height={height}
            onClick={() => onChange(item)}
          >
            {icon ? (
              <IconFont
                name={icon}
                color={isActive ? theme.colors.textLight : theme.colors.text}
                size={iconSize}
                style={{ marginRight: 10 }}
              />
            ) : null}
            <TabText active={isActive}>{label}</TabText>
          </TabItem>
        )
      })}
    </TabsContainer>
  )
}
